import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "./api/axios";
import { FaEye, FaEyeSlash } from "react-icons/fa";

import { useEffect } from "react";
export default function AdminLogin() {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState("");
  useEffect(() => {
    // Clear localStorage tokens
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");

    // Clear any cookies if they exist
    document.cookie =
      "access_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
    document.cookie =
      "refresh_token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";

    // Clear any sessionStorage if used
    sessionStorage.clear();

    console.log("Admin login page loaded - all tokens cleared");
  }, []);

  // Di AdminLogin.js, setelah login berhasil
async function handleLogin(e) {
  e.preventDefault();
  const username = e.target.username.value;
  const password = e.target.password.value;

  try {
    // Step 1: Login
    const loginRes = await api.post("/login", { username, password });

    const { access_token, refresh_token } = loginRes.data;
    localStorage.setItem("access_token", access_token);
    localStorage.setItem("refresh_token", refresh_token);

    // Step 2: Fetch profile
    const profileRes = await api.get("/profile");
    const profile = profileRes.data;
    
    console.log("Admin profile after login:", profile); // Debug log
    
    // Step 3: Role check
    if (profile.role !== "admin") {
      setError("Akun Anda tidak memiliki akses admin.");
      localStorage.removeItem("access_token");
      localStorage.removeItem("refresh_token");
      return;
    }

    // Step 4: Simpan admin profile untuk logging
    const adminData = {
      ID: profile.ID || profile.id,
      username: profile.username || profile.Username || username, // fallback ke username input
      email: profile.email,
      role: profile.role,
      name: profile.name || profile.Name
    };
    
    console.log("Saving admin data:", adminData); // Debug log
    
    localStorage.setItem("admin_profile", JSON.stringify(adminData));
    localStorage.setItem("user_data", JSON.stringify(adminData)); // Backup

    // Success
    navigate("/admin/adminlist");
  } catch (err) {
    setError("Login gagal. Periksa kembali username dan password Anda.");
    console.error(err);
  }
}

  return (
    <div className="min-h-screen flex items-center justify-center bg-white px-4">
      <div className="max-w-sm w-full text-center">
        <img
          src="/logohallostroke.png"
          alt="Logo Hallo Stroke"
          className="mx-auto mb-4 w-48 object-contain"
        />
        <h2 className="text-lg text-gray-600 mb-8">Login sebagai Admin</h2>

        <form onSubmit={handleLogin} className="space-y-4 text-left">
          <div>
            <label className="text-sm font-medium block mb-1">Username</label>
            <input
              name="username"
              type="text"
              required
              placeholder="Masukkan username"
              className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400"
            />
          </div>
          <div>
            <label className="text-sm font-medium block mb-1">Password</label>
            <div className="relative">
              <input
                name="password"
                type={showPassword ? "text" : "password"}
                required
                placeholder="Masukkan password"
                className="w-full border rounded px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-400 pr-10"
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute right-3 top-2.5 text-gray-500"
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
          </div>
          <button
            type="submit"
            className="w-full bg-blue-500 hover:bg-blue-600 text-white rounded py-2 transition"
          >
            Log in
          </button>
        </form>
      </div>
    </div>
  );
}
